export const formatNameForTestid = (name: string | undefined) => {
  if (!name) {
    return ''
  }

  return name.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
}
